import React, {useMemo} from "react";
import {
  CalendarOutlined,
  CreditCardOutlined,
  GlobalOutlined,
  MessageOutlined,
  ScheduleOutlined,
} from "@ant-design/icons";
import PlaneIcon from "../../../../../media/icons/plane-icon.svg?react";
import {roles} from "../../../../../config/acl/roles";
import {Route} from "../../../../../config/acl/routes/Route";
import {useAppSelector} from "../../../../../store/store";

export type SettingsQuickLink = {
  route: Route;
  icon: React.ReactNode;
  messageId: string;
  defaultMessage: string;
};

const SETTINGS_QUICK_LINKS: SettingsQuickLink[] = [
  {
    route: Route.messageTemplates,
    icon: <MessageOutlined style={{fontSize: 18}}/>,
    messageId: "messageTemplatesRoute.title",
    defaultMessage: "Message Templates",
  },
  {
    route: Route.subscription,
    icon: <CreditCardOutlined style={{fontSize: 18}}/>,
    messageId: "subscriptionRoute.title",
    defaultMessage: "Subscription",
  },
  {
    route: Route.eventCalendar,
    icon: <CalendarOutlined style={{fontSize: 18}}/>,
    messageId: "eventCalendarRoute.title",
    defaultMessage: "Event Calendar",
  },
  {
    route: Route.fleet,
    icon: <PlaneIcon style={{fontSize: 18, width: 18, height: 18, color: "currentColor", fill: "currentColor"}}/>,
    messageId: "fleetRoute.title",
    defaultMessage: "Aircraft Fleet",
  },
  {
    route: Route.schedulePrivate,
    icon: <ScheduleOutlined style={{fontSize: 18}}/>,
    messageId: "schedulePrivateRoute.title",
    defaultMessage: "Private Schedule",
  },
  {
    route: Route.schedulePublic,
    icon: <GlobalOutlined style={{fontSize: 18}}/>,
    messageId: "schedulePublicRoute.title",
    defaultMessage: "Public Schedule",
  },
];

export const useSettingsQuickLinks = (): SettingsQuickLink[] => {
  const role = useAppSelector(state => state.auth.role);

  return useMemo(() => {
    const sidebarRoutes = new Set(roles[role].navigation.sidebar);

    return SETTINGS_QUICK_LINKS.filter(
      link => link.route !== Route.settings && sidebarRoutes.has(link.route),
    );
  }, [role]);
};
